module.exports = {
    data: {
        0: {
            name: "Rogue Scout (Normal)",
            attributes: "Fire Arrow",
            type: "rogue"
        },
        1: {
            name: "Rogue Scout (Normal)",
            attributes: "Cold Arrow",
            type: "rogue"
        },
        2: {
            name: "Rogue Scout (Nightmare)",
            attributes: "Fire Arrow",
            type: "rogue"
        },
        3: {
            name: "Rogue Scout (Nightmare)",
            attributes: "Cold Arrow",
            type: "rogue"
        },
        4: {
            name: "Rogue Scout (Hell)",
            attributes: "Fire Arrow",
            type: "rogue"
        },
        5: {
            name: "Rogue Scout (Hell)",
            attributes: "Cold Arrow",
            type: "rogue"
        },
        6: {
            name: "Desert Mercenary (Normal)",
            attributes: "Combat",
            aura: "Prayer aura",
            type: "desert"
        },
        7: {
            name: "Desert Mercenary (Normal)",
            attributes: "Defensive",
            aura: "Defiance aura",
            type: "desert"
        },
        8: {
            name: "Desert Mercenary (Normal)",
            attributes: "Offensive",
            aura: "Blessed aim aura",
            type: "desert"
        },
        9: {
            name: "Desert Mercenary (Nightmare)",
            attributes: "Combat",
            aura: "Thorns aura",
            type: "desert"
        },
        10: {
            name: "Desert Mercenary (Nightmare)",
            attributes: "Defensive",
            aura: "Holy Freeze aura",
            type: "desert"
        },
        11: {
            name: "Desert Mercenary (Nightmare)",
            attributes: "Offensive",
            aura: "Might aura",
            type: "desert"
        },
        12: {
            name: "Desert Mercenary (Hell)",
            attributes: "Combat",
            aura: "Prayer aura",
            type: "desert"
        },
        13: {
            name: "Desert Mercenary (Hell)",
            attributes: "Defensive",
            aura: "Defiance aura",
            type: "desert"
        },
        14: {
            name: "Desert Mercenary (Hell)",
            attributes: "Offensive",
            aura: "Blessed aim aura",
            type: "desert"
        },
        15: {
            name: "Eastern Sorceror (Normal)",
            attributes: "Fire",
            type: "eastern"
        },
        16: {
            name: "Eastern Sorceror (Normal)",
            attributes: "Cold",
            type: "eastern"
        },
        17: {
            name: "Eastern Sorceror (Normal)",
            attributes: "Lightning",
            type: "eastern"
        },
        18: {
            name: "Eastern Sorceror (Nightmare)",
            attributes: "Fire",
            type: "eastern"
        },
        19: {
            name: "Eastern Sorceror (Nightmare)",
            attributes: "Cold",
            type: "eastern"
        },
        20: {
            name: "Eastern Sorceror (Nightmare)",
            attributes: "Lightning",
            type: "eastern"
        },
        21: {
            name: "Eastern Sorceror (Hell)",
            attributes: "Fire",
            type: "eastern"
        },
        22: {
            name: "Eastern Sorceror (Hell)",
            attributes: "Cold",
            type: "eastern"
        },
        23: {
            name: "Eastern Sorceror (Hell)",
            attributes: "Lightning",
            type: "eastern"
        },
        24: {
            name: "Barbarian (Normal)",
            type: "barbarian"
        },
        25: {
            name: "Barbarian (Normal)",
            type: "barbarian"
        },
        26: {
            name: "Barbarian (Nightmare)",
            type: "barbarian"
        },
        27: {
            name: "Barbarian (Nightmare)",
            type: "barbarian"
        },
        28: {
            name: "Barbarian (Hell)",
            type: "barbarian"
        },
        29: {
            name: "Barbarian (Hell)",
            type: "barbarian"
        }
    },
    rogue: {
        0: "Aliza",
        1: "Amplisa",
        2: "Annor",
        3: "Abhaya",
        4: "Elly",
        5: "Paige",
        6: "Basanti",
        7: "Blaise",
        8: "Kyoko",
        9: "Klaudia",
        10: "Kundri",
        11: "Kyle",
        12: "Visala",
        13: "Elexa",
        14: "Floria",
        15: "Fiona",
        16: "Gwinni",
        17: "Gaile",
        18: "Hannah",
        19: "Heather",
        20: "Iantha",
        21: "Diane",
        22: "Isolde",
        23: "Divo",
        24: "Ithera",
        25: "Itonya",
        26: "Liene",
        27: "Maeko",
        28: "Mahala",
        29: "Liaza",
        30: "Meghan",
        31: "Olena",
        32: "Oriana",
        33: "Ryann",
        34: "Rozene",
        35: "Raissa",
        36: "Sharyn",
        37: "Shikha",
        38: "Debi",
        39: "Tylena",
        40: "Wendy"
    },
    desert: {
        0: "Hazade",
        1: "Alhizeer",
        2: "Azrael",
        3: "Ahsab",
        4: "Chalan",
        5: "Haseen",
        6: "Razan",
        7: "Emilio",
        8: "Pratham",
        9: "Fazel",
        10: "Jemali",
        11: "Kasim",
        12: "Gulzar",
        13: "Mizan",
        14: "Leharas",
        15: "Durga",
        16: "Neeraj",
        17: "Ilzan",
        18: "Zanarhi",
        19: "Waheed",
        20: "Vikhyat"
    },
    eastern: {
        0: "Jelani",
        1: "Barani",
        2: "Jabari",
        3: "Devak",
        4: "Raldin",
        5: "Telash",
        6: "Ajheed",
        7: "Narphet",
        8: "Khaleel",
        9: "Phaet",
        10: "Geshef",
        11: "Vanji",
        12: "Haphet",
        13: "Thadar",
        14: "Yatiraj",
        15: "Rhadge",
        16: "Yashied",
        17: "Jarulf",
        18: "Flux",
        19: "Scorch"
    },
    barbarian: {
        0: "Varaya",
        1: "Khan",
        2: "Klisk",
        3: "Bors",
        4: "Brom",
        5: "Wiglaf",
        6: "Hrothgar",
        7: "Scyld",
        8: "Healfdane",
        9: "Herogar",
        10: "Halgaunt",
        11: "Hygelac",
        12: "Egtheow",
        13: "Bohdan",
        14: "Wulfgar",
        15: "Hild",
        16: "Heatholaf",
        17: "Weder",
        18: "Vikhyat",
        19: "Unferth",
        20: "Sigemund",
        21: "Heremod",
        22: "Hengest",
        23: "Folcwald",
        24: "Frisian",
        25: "Hnaef",
        26: "Guthlaf",
        27: "Oslaf",
        28: "Yrmenlaf",
        29: "Garmund",
        30: "Freawaru",
        31: "Eadgils",
        32: "Onela",
        33: "Damien",
        34: "Erfor",
        35: "Weohstan",
        36: "Wulf",
        37: "Bulwye",
        38: "Lief",
        39: "Magnus",
        40: "Klatu",
        41: "Drus",
        42: "Hoku",
        43: "Kord",
        44: "Uther",
        45: "Ip",
        46: "Ulf",
        47: "Tharr",
        48: "Kaelim",
        49: "Ulric",
        50: "Alaric",
        51: "Ethelred",
        52: "Caden",
        53: "Elgifu",
        54: "Tostig",
        55: "Alcuin",
        56: "Emund",
        57: "Sigurd",
        58: "Gorm",
        59: "Hollis",
        60: "Ragnar",
        61: "Torkel",
        62: "Wulfstan",
        63: "Alban",
        64: "Barloc",
        65: "Bill",
        66: "Theodoric"
    }
}



// WEBPACK FOOTER //
// ./src/lib/merc-map.js